<p-wrapper titleWrapper="Page introuvable !" [withHomeButton]="true">
  <div body>
    <div class="text-center">
      <h1 class="text-danger">404</h1>
      <p>
        Cette page est inexistante, veuillez contacter le service de support ou
        votre administrateur !
      </p>
    </div>
  </div>
</p-wrapper>
